import { Link } from 'react-router-dom';
import AnimeCard from '@/components/feature/AnimeCard';
import { animeList } from '@/mocks/anime';

export default function LatestSection() {
  const latest = [...animeList]
    .sort((a, b) => (a.updateDate < b.updateDate ? 1 : -1))
    .slice(0, 8);

  return (
    <section className="w-full px-4 md:px-8 py-10 bg-background-50">
      <div className="flex items-end justify-between mb-6">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">最新动漫</h2>
          <p className="text-sm text-foreground-500 mt-1">最近更新的剧集，紧跟追番节奏</p>
        </div>
        <Link
          to="/search"
          className="text-sm text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap flex items-center gap-1"
        >
          查看全部
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 gap-4">
        {latest.map((anime) => (
          <AnimeCard key={anime.id} anime={anime} />
        ))}
      </div>
    </section>
  );
}